import { Coordinate, NumericCoordinate } from 'models/locations'

export const coordinateFormatter = ({ latitude, longitude }: Coordinate): NumericCoordinate => {
  return {
    latitude: parseFloat(latitude as string),
    longitude: parseFloat(longitude as string),
  }
}
